<template>
  <tr class="triple">
    <td class="align-middle" v-text="subject"></td>
    <td class="align-middle" v-text="predicate"></td>
    <td class="align-middle" v-text="object"></td>
    <td>
      <div class="btn-group" role="group" aria-label="Memory tools">
        <button class="btn btn-danger btn-sm" @click="deleteTriple">Forget</button>
      </div>
    </td>
  </tr>
</template>

<script type="text/babel">
export default {
  name: 'TripleComponent',
  props: {
    index: Number,
    subject: String,
    predicate: String,
    object: String
  },
  data: () => ({}),
  methods: {
    deleteTriple: function () {
      const _self = this
      _self.$emit('delete', _self.index, {
        subject: _self.subject,
        predicate: _self.predicate,
        object: _self.object
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" lang="css" scoped>
</style>
